import Loader from "../../../components/Loader/Loader";
import Form from "../../../components/Form/Form";
import React, { useEffect, useState } from "react";
import Input from "../../../components/Input/Input";
import ToggleButton from "../../../components/ToggleButton/ToggleButton";
import { ReaderModel, ReaderModelEnum } from "../../../constants/readers-model";
import ReadersService from "../../../services/ReadersService";
import { useUserStore } from "../../../contexts/userStore";
import { useSSEContext } from "../../../contexts/sse";
import { IoAlertCircleOutline } from "react-icons/io5";

export function ConfigQrcode(props) {
   const [showLoader, setShowLoader] = useState(false);
   const [dynamicPeriod, setDynamicPeriod] = useState();
   const [port, setPort] = useState();
   const [enabled, setEnabled] = useState(false);
   const { selectedCondominio, selectedLicenceId } = useUserStore();
   const [status, setStatus] = useState();
   const { sseReceived } = useSSEContext();

   function updateConfig(config) {
      setPort(config.port ?? 5001);
      setEnabled(config.enabled);
      setStatus(config?.status);
      setDynamicPeriod(config.configuration.dynamicPeriod ?? 120);
   }

   useEffect(() => {
      if (sseReceived?.action === 'serviceConfigUpdate' && sseReceived?.content?.model === ReaderModelEnum.QRCODE) {
         updateConfig(sseReceived.content);
      }
   }, [sseReceived]);

   async function fetchConfig() {
      const response = await ReadersService.getReaderServiceConfig(ReaderModelEnum.QRCODE, selectedCondominio, selectedLicenceId);
      const config = response.data;
      updateConfig(config);
   }

   useEffect(() => {
      if (selectedCondominio) {
         fetchConfig();
      }
   }, [selectedCondominio]);

   async function handleSubmit(event) {
      event.preventDefault();
      const payload = {
         dynamicPeriod,
         port,
         enabled,
         configuration: {}
      }
      await ReadersService.updateReaderServiceConfig(ReaderModelEnum.QRCODE, selectedCondominio, selectedLicenceId, payload);
   }

   return (
      <React.Fragment>
         {showLoader ? (
            <Loader />
         ) : (
            <Form
               handleSubmit={handleSubmit}
               type={props.type}
               navigateCancelUrl="../consulta-readers"
            >
               {status === 'notSynced' && (
                  <div className='alert alert-warning'>
                     <IoAlertCircleOutline size={20} />
                     <span><b>Atenção:</b> O serviço para os dispositivos {ReaderModel.QRCODE.name} não está sincronizado com o equipamento, os eventos do dispositivo não serão recebidos e processados!</span>
                     <a href="void(0)" onClick={e => handleSubmit(e)}>Sincronizar</a>
                  </div>
               )}
               {status != null && !['notSynced', 'synced'].includes(status) && (
                  <div className='alert alert-danger'>
                     <IoAlertCircleOutline size={20} />
                     <span><b>Atenção:</b> A sincronização do serviço para os dispositivos {ReaderModel.QRCODE.name} registrou um erro, os eventos do dispositivo não serão recebidos e processados!</span>
                     <a href="void(0)" onClick={e => handleSubmit(e)}>Sincronizar</a>
                  </div>
               )}
               <div className="grid grid-cols-2 w-full gap-3">
                  <div>
                     <Input
                        name="dynamicPeriod"
                        id="dynamicPeriod"
                        type="number"
                        labelText="Período Dinâmico (s)"
                        value={dynamicPeriod}
                        onChange={({ target }) => setDynamicPeriod(target.value)}
                        required={true}
                     />
                     <p className="text-(--textColor) mt-1.5! w-full text-left"><b className="font-bold text-red-400">OBSERVAÇÃO</b>: Alterar o Periodo dinâmico pode invalidar todos os QRCodes gerados anteriormente.</p>
                  </div>
                  <Input
                     name="port"
                     id="port"
                     type="number"
                     labelText="Porta de Serviço TCP"
                     value={port}
                     onChange={({ target }) => setPort(target.value)}
                     required={true}
                  />
                  <ToggleButton
                     style={{ width: 'fit-content', paddingTop: '15px' }}
                     label={`Habilitado`}
                     onChange={(e) => setEnabled(e.target.checked)}
                     selected={enabled}
                  />
               </div>
            </Form>
         )}
      </React.Fragment>
   );
}